import { fromEvent } from 'rxjs';
import Carousel from '@components/carousel/dynamicCarousel';

const onDocumentContentLoaded$ = fromEvent(document, 'DOMContentLoaded');
const lifestyleInsightsSelector = "[data-section-name='lifestyleInsights']";
const lifestyleInsightsContainer = document.querySelector(lifestyleInsightsSelector);

/**
 * Sets up carousel settings including selectors for item list, previous, and next arrows.
 * Creates a new Carousel instance and applies the settings.
 *
 * @function setLifestyleInsightsCarousel
 * @returns {void}
 */
const setLifestyleInsightsCarousel = function() {
  if (!lifestyleInsightsContainer) {
    return;
  }

  const settings = {
    itemListQuerySelector: `${lifestyleInsightsSelector} [data-item-list]`,
    previousQuerySelector: `${lifestyleInsightsSelector} [data-left-arrow]`,
    nextQuerySelector: `${lifestyleInsightsSelector} [data-right-arrow]`,
  };

  const carousel = new Carousel();
  carousel.setSettings(settings);
  carousel.create();
}

/* Subscribing to the `onDocumentContentLoaded$` observable stream and executing
the `setLifestyleInsightsCarousel` function whenever the `DOMContentLoaded`
event is triggered on the document. This setup ensures that the `setLifestyleInsightsCarousel`
function is called when the document content has finished loading, allowing the
carousel setup to be triggered at the appropriate time. */
onDocumentContentLoaded$.subscribe(setLifestyleInsightsCarousel);